import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';
import { TranslateService } from '@ngx-translate/core';
import { convertUTCDateToLocalDate } from '../../../Helpers/utilities/utilities';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
  ],
})
export class DatePickerComponent
  extends ControlValueAccessorDirective
  implements OnChanges, AfterViewInit
{
  @Output() dateChanged: EventEmitter<string> = new EventEmitter();
  @Input() maxDate!: Date;
  @Input() minDate!: Date;
  @Input() readOnly: boolean = false;
  @Input() isTodayDisabled: boolean = false;
  @Input() placeholder: string = '';
  @Input() appearance: MatFormFieldAppearance = 'outline';
  private _disabledDates: Date[] = [];
  // Input to receive initial disabled dates
  @Input() disabledDates: Date[] = [];
  @ViewChild('picker') picker!: MatDatepicker<Date>;

  // get disabledDates(): Date[] {
  //   // Add custom logic here if needed
  //   return this._disabledDates;
  // }
  lang: string = '';
  constructor(
    private dateAdapter: DateAdapter<any>,
    private translate: TranslateService,
    private renderer: Renderer2
  ) {
    super();
    this.lang = this.translate.currentLang;
    this.setDatePickerLocale();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabledDates']) {
      this._disabledDates = changes['disabledDates'].currentValue;
    }
  }

  ngOnInit(): void {}

  public setDatePickerLocale() {
    if (this.lang === 'ar') {
      this.dateAdapter.setLocale('ar-AE');
      const originalGetDayOfWeekNames = this.dateAdapter.getDayOfWeekNames.bind(
        this.dateAdapter
      );
      this.dateAdapter.getDayOfWeekNames = (
        style: 'long' | 'short' | 'narrow'
      ) => {
        if (style === 'short' || style === 'narrow') {
          return [
            'الأحد',
            'الاثنين',
            'الثلاثاء',
            'الأربعاء',
            'الخميس',
            'الجمعة',
            'السبت',
          ];
        }
        return originalGetDayOfWeekNames(style);
      };
    } else {
      this.dateAdapter.setLocale('en-US');
    }
  }

  override change() {
    this.value = convertUTCDateToLocalDate(this.value);
    this.onChange(this.value);
    this.dateChanged.emit(this.value);
  }

  // Date filter function
  dateFilter = (date: Date | null): boolean => {
    if (this._disabledDates.length == 0) return true;

    const disabledDates: Date[] = [...this._disabledDates];
    if (!date) return false;
    // Convert date to timestamp for comparison
    const day = date.getDate();
    // Check if date is in disabledDates array
    return !disabledDates.some(
      (disabledDate) => disabledDate.getDate() === day
    );
  };

  ngAfterViewInit() {
    this.picker.openedStream.subscribe(() => {
      const calendarElement = document.querySelector('.mat-datepicker-content');
      if (calendarElement) {
        this.renderer.addClass(
          calendarElement,
          this.isTodayDisabled ? 'todayDisable' : 'todayAvailable'
        );
      }
    });
  }
}
